/** Runtime configuration for signaling and WebRTC. */

/** Default chunk size for file slicing (1 MiB). Configurable per transfer. */
export const DEFAULT_CHUNK_SIZE = 1024 * 1024;

/**
 * DataChannel backpressure thresholds. We keep `bufferedAmount` between the low
 * and high watermarks so we never balloon memory while still saturating the
 * link. Tuned for >50GB transfers under the 200MB memory budget.
 */
export const BUFFER_HIGH_WATER = 8 * 1024 * 1024; // pause sending above this
export const BUFFER_LOW_WATER = 1 * 1024 * 1024; // resume sending below this

/** STUN servers (no TURN in V1 — see spec). */
export const ICE_SERVERS: RTCIceServer[] = [
  { urls: ['stun:stun.l.google.com:19302', 'stun:stun1.l.google.com:19302'] },
];

/**
 * Base URL of the signaling Worker. In dev, falls back to the Vite proxy /
 * same origin. Override with VITE_SIGNALING_URL at build time.
 */
export function signalingBaseUrl(): string {
  const env = import.meta.env.VITE_SIGNALING_URL;
  if (env) return env.replace(/\/$/, '');
  return window.location.origin;
}

/** Build the WebSocket signaling URL for a room + role. */
export function signalingWsUrl(roomId: string, role: 'sender' | 'receiver'): string {
  const base = signalingBaseUrl();
  const wsBase = base.replace(/^http/, 'ws');
  return `${wsBase}/ws/${encodeURIComponent(roomId)}?role=${role}`;
}
